import { Link } from '@remix-run/react'
import { useSetAtom } from 'jotai'
import { isLoadingAtom } from '~/lib/jotai/loading'
interface CommonFormButtonProps {
    backBtnText?: string
    nextBtnText?: string
}

type ConditionalProps =
    | { backLink: string; hideBack?: never }
    | { backLink?: never; hideBack: boolean }

export function FormButtons({
    backLink,
    backBtnText,
    nextBtnText,
    hideBack,
}: CommonFormButtonProps & ConditionalProps) {
    const setLoading = useSetAtom(isLoadingAtom)

    return (
        <div className='flex justify-center gap-4'>
            {!hideBack && (
                <Link to={`../${backLink}`} tabIndex={-1}>
                    <button
                        type='button'
                        className='px-6 py-3 bg-slate-200 text-gray-700 rounded-lg transition-colors duration-300 hover:bg-slate-400'
                        onClick={() => setLoading(true)}
                    >
                        {backBtnText ?? 'Back'}
                    </button>
                </Link>
            )}

            <button
                type='submit'
                className='px-6 py-3 bg-companyRed text-white rounded-lg transition-colors duration-300 hover:bg-red-700'
            >
                {nextBtnText ?? 'Next'}
            </button>
        </div>
    )
}
